import React, {useState} from 'react';
import { Container, Row, Col } from "react-bootstrap";
import VerticalPixelImage from './VerticalPixelImage';
import { StaticImage } from "gatsby-plugin-image";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Alert from "react-bootstrap/Alert";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import {SubscriptionViewModel} from "../view-models/subscription-view-model";

export default function MoreInfos(props) {
    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha()
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const view_model = new SubscriptionViewModel();

    const subscribe = async () => {
        setSubmitted(true);
        if (!executeRecaptcha) {
            return
        }

        if(email && view_model.validateEmailFormat(email)) {
            const token = await executeRecaptcha('homepage')
            const was_subscribed = await view_model.subscribe(email, token);
            setShowError(!was_subscribed);
            setShowSuccess(was_subscribed);
        }
    }

    return (
        <div className="more-infos-container py-5">
            <Container>
                <Row>
                    <Col className="d-none d-lg-flex align-items-center" lg={1}>
                        <VerticalPixelImage />
                    </Col>
                    <Col className="px-lg-5 mb-4 mb-lg-0" lg={5}>
                        <Row className="mb-2 mt-lg-4 m-lg-0 p-lg-0">
                            <Col className="d-flex d-lg-none ps-0" xs={2}>
                                <VerticalPixelImage />
                            </Col>
                            <Col className="m-lg-0 p-lg-0 more-infos-title-container" xs={8}>
                                <h1 className="more-infos-title fw-bold mb-5 mb-lg-2">{props.title}</h1>
                                <p className="more-infos-description mb-0 text-center">{props.description} <span className="fw-bold">{props.descriptionInBold}</span></p>
                            </Col>
                            <Col className="d-flex d-lg-none justify-content-end pe-1 pe-lg-1" xs={2}>
                                <VerticalPixelImage />
                            </Col>
                        </Row>
                        <p className="more-infos-description">
                            {props.descriptionFirst}
                            {props.descriptionSecond}
                            {props.descriptionThird}
                        </p>
                    </Col>
                    <Col className="px-0" lg={5}>
                        <div className="pe-lg-5 d-flex flex-column mt-lg-5 m-lg-0 p-3 p-lg-0">
                            <StaticImage
                                className="mb-4"
                                src="../images/bars-red.svg"
                                alt="Divisor"
                                height={20}
                                placeholder="none"
                            />
                            <div className="w-full">
                                <div id="mc_embed_signup" className="w-full">
                                    <Form
                                        id="mc-embedded-subscribe-form"
                                        name="mc-embedded-subscribe-form"
                                        className="validate w-full"
                                        target="_blank"
                                        noValidate
                                        validated={submitted}
                                    >
                                        <InputGroup className="mb-3">
                                            <Form.Control
                                                type="email"
                                                value={email}
                                                name="EMAIL"
                                                className="required p-2 border border-black rounded"
                                                id="mce-EMAIL"
                                                placeholder="email..."
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                            <Form.Control
                                                type="button"
                                                value="ENVIAR"
                                                name="subscribe"
                                                id="mc-embedded-subscribe"
                                                className="btn btn-danger text-white fw-bold bg-blue py-2 px-10 text-lg"
                                                style={{maxWidth : 150}}
                                                onClick={subscribe}
                                            />
                                        </InputGroup>
                                        <Alert show={showSuccess} variant="primary">
                                            Nos pondremos en contacto muy pronto.
                                        </Alert>
                                        <Alert show={showError} variant="danger">
                                            Ocurrió un error al tratar de subscribirte.
                                        </Alert>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="d-none d-lg-flex align-items-center justify-content-end" lg={1}>
                        <VerticalPixelImage />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
